// extracted by mini-css-extract-plugin
export default {"content":"ResaleSubmission_content__+eHC-"};